import * as React from "react";
import { useEffect, useState, useMemo, useCallback } from "react";
import { useDataProvider } from "react-admin";
import useAiInsight from "../../../Components/AiAssistant/useAiInsight";
import { buildAiBaseParams } from "../../../Components/AiAssistant/buildAiBaseParams";
import { Button, Dialog, DialogContent, Typography } from "@material-ui/core";
import GaugeChart from "../../../Components/CustomChart/GaugeChart";
import { ViewList } from "@material-ui/icons";
import CockpitOutOfStockViewList from "./CockpitOutOfStockViewList";

const CockpitOutOfStock = ({ filterParams }) => {
  const dataProvider = useDataProvider();

  const [chartData, setChartData] = useState([] as any);
  const [chartValue, setChartValue] = useState(0);
  const [open, setOpen] = useState(false);

  const resourceEndpoint = "pbhrequestorders/cockpit/outofstock";
  const resourceViewEndpoint = "pbhrequestorders/cockpit/outofstockview";

  const subArcs = [
    {
      limit: 15,
      color: "#5BE12C",
      showTick: true,
    },
    {
      limit: 100,
      color: "#EA4228",
      showTick: true,
    },
  ];

  const insightParams = useMemo(() => {
    if (!chartData.length) return null;
    const sum = chartData.reduce((s: number, d: any) => s + d.outOfStock, 0);
    return {
      ...buildAiBaseParams(filterParams),
      totalPnCount: chartData.length.toString(),
      outOfStockCount: sum.toString(),
      outOfStockRate: chartValue.toFixed(2),
    };
  }, [filterParams, chartValue, chartData]);
  useAiInsight("cockpitoutofstock", insightParams);

  const GetChartData = useCallback(async () => {
    await dataProvider
      .getList(resourceEndpoint, {
        pagination: { page: 1, perPage: 999999 },
        sort: { field: "id", order: "ASC" },
        filter: filterParams,
      })
      .then(({ data }) => {
        const sum = data.reduce((sum, current) => sum + current.outOfStock, 0);
        const avg = Number(((sum / data.length) * 100).toFixed(2));
        setChartData(data);
        setChartValue(avg);
      })
      .catch(error => {
        console.log(error);
      });
  }, [filterParams, dataProvider]);

  useEffect(() => {
    GetChartData();
  }, [GetChartData]);

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" align="center">
        Out of Stock Rate
      </Typography>
      <GaugeChart value={chartValue} subArcs={subArcs} />
      <Button fullWidth startIcon={<ViewList />} onClick={() => setOpen(true)} color="primary">
        View
      </Button>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <CockpitOutOfStockViewList
            filterParams={filterParams}
            resource={resourceViewEndpoint}
            basePath={resourceViewEndpoint}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CockpitOutOfStock;
